import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {Media} from '../../../api/models/media';
import * as S3 from "aws-sdk/clients/s3";
import { Camera } from '../../../api/models/camera';


@Component({
  selector: 'app-media-show',
  templateUrl: './media-show.component.html',
  styleUrls: ['./media-show.component.css']
})
export class MediaShowComponent implements OnInit {

  @Input() url: string;
  @Input() media: Media;
  @Input() cameras: Camera[];
  @Input() selectedCamera: number;
  @Output() folderChanged: EventEmitter<number> = new EventEmitter();
  defaultCamera: number;
  private bucket: S3;
  fileUrl;
  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit() {
    console.log("CAMERAS =>", this.cameras, this.selectedCamera);
    this.defaultCamera = this.selectedCamera;
    console.log("CURRENT FOLDER MEDIA =>", this.selectedCamera);
  }

  // If the selected camera's orientation is "Portrait", return a rotation style.
  get transformStyle(): string {
    const cam = this.cameras.find(camera => camera.id === this.selectedCamera);
    if (cam && cam.orientation === 'Portrait') {
      return 'rotate(90deg) scale(0.7)';
    }
    return 'none';
  } 

  async downloadImage() {
    const itemURL = await this.bucket.getSignedUrl('getObject', {
      Bucket: "buildevolution", 
      Key: this.media.project + '/' + this.media.folder + '/' + this.media.name, 
      Expires: 60*5
    });
    const image = await fetch(itemURL)
    const imageBlob = await image.blob();
    const imageURL = URL.createObjectURL(imageBlob);
    const link = document.createElement('a')
    link.href = imageURL
    link.download = 'buildevolution-image'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  changeFolder() {
    this.folderChanged.emit(this.defaultCamera);
  }

  getHoure(): string {
    return this.media.name.slice(8, 10) + ':' + this.media.name.slice(10, 12);
  }

  getDate(): string {
    return this.media.name.slice(0, 4) + '-' + this.media.name.slice(4, 6) + '-' + this.media.name.slice(6, 8);
  }
}
